<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tablePath">安卓APK白名单列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel v-loading="uploading"
                  element-loading-text="正在上传APK文件，请稍候..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.7)">
      <span slot="header">表单（{{appTypeLabel}}）</span>
      <el-form ref="form"
               :model="form"
               :rules="computedFormRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="名称"
                          prop="title">
              <el-input v-model="form.title"
                        :disabled="this.form.userid > 0"></el-input>
            </el-form-item>
            <el-form-item label="安卓版本号"
                          prop="vision">
              <el-input v-model="form.vision"></el-input>
            </el-form-item>
            <el-form-item label="安卓APK包"
                          prop="loadurl">
              <el-upload
                class="upload-demo"
                drag
                v-model="form.loadurl"
                :limit="1"
                accept=".apk"
                :on-remove="handleRemove"
                :http-request="uploadRequest"
                :disabled="uploading"
                action="https://jsonplaceholder.typicode.com/posts/"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip"
                     slot="tip">只能上传APK文件</div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="isAlg"
                          label="APK签名(md5)"
                          prop="apk_signature">
              <el-input v-model="form.apk_signature"></el-input>
            </el-form-item>
            <el-form-item label="IOS版本号"
                          prop="ios_version">
              <el-input v-model="form.ios_version"></el-input>
            </el-form-item>
            <el-form-item label="IOS下载链接"
                          prop="ios_loadurl">
              <el-input v-model="form.ios_loadurl"></el-input>
            </el-form-item>
            <el-form-item v-if="isAlg"
                          label="是否为白名单apk"
                          prop="type">
              <el-radio-group v-model="form.type"
                              @change="(value) => {if (value === '0') form.type = ''}">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>不是
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="强制升级"
                          prop="force_update">
              <el-radio-group v-model="form.force_update"
                              @change="(value) => {if (value === '0') form.force_update = ''}">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>不是
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="isClb"
                          label="是否开启热更新"
                          prop="enable_hot_update">
              <el-radio-group v-model="form.enable_hot_update"
                              @change="onEnableHotUpdateChange">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="isClb && Number(form.enable_hot_update) === 1"
                          label="是否强制"
                          prop="force_hot_update">
              <el-radio-group v-model="form.force_hot_update">
                <el-radio :label="1"
                          border>是
                </el-radio>
                <el-radio :label="0"
                          border>否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="更新日志">
              <el-input v-model="form.changelog"
                        type="textarea">
              </el-input>
            </el-form-item>

          </div>

        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../platform-androidapk-test.rules.js'

const APP_TYPE_ALG = 1
const APP_TYPE_CLB = 2

export default {
  components: {},
  data () {
    return {
      id: 0,
      formRules,
      uploading: false,
      form: {
        title: null,
        vision: null,
        ios_version: null,
        ios_loadurl: null,
        changelog: null,
        force_update: 0,
        type: 0,
        loadurl: null,
        apk_signature: null,
        app_type: APP_TYPE_ALG,
        enable_hot_update: 0,
        force_hot_update: 0,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.platformAndroidapkTest.options,
    }),
    isAlg () {
      return Number(this.form.app_type) === APP_TYPE_ALG
    },
    isClb () {
      return Number(this.form.app_type) === APP_TYPE_CLB
    },
    appTypeLabel () {
      return this.isClb ? '查理宝' : '爱零工'
    },
    tablePath () {
      return {
        path: '/platform-androidapk-test/table',
        query: {app_type: String(this.form.app_type || APP_TYPE_ALG)},
      }
    },
    computedFormRules () {
      const rules = Object.assign({}, this.formRules)
      if (!this.isAlg) {
        delete rules.apk_signature
      }
      if (!this.isClb) {
        delete rules.enable_hot_update
        delete rules.force_hot_update
      } else if (Number(this.form.enable_hot_update) !== 1) {
        delete rules.force_hot_update
      }
      return rules
    },
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    resolveAppTypeFromRoute () {
      const queryType = this.$route.query.app_type
      if (queryType !== undefined && queryType !== null && queryType !== '') {
        return Number(queryType) === APP_TYPE_CLB ? APP_TYPE_CLB : APP_TYPE_ALG
      }
      return APP_TYPE_ALG
    },
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      } else {
        this.form.app_type = this.resolveAppTypeFromRoute()
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getPlatformAndroidapkTestDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        if (data.app_type === undefined || data.app_type === null || data.app_type === '') {
          this.form.app_type = APP_TYPE_ALG
        } else {
          this.form.app_type = Number(data.app_type) === APP_TYPE_CLB ? APP_TYPE_CLB : APP_TYPE_ALG
        }
        this.form.enable_hot_update = Number(data.enable_hot_update) === 1 ? 1 : 0
        this.form.force_hot_update = Number(data.force_hot_update) === 1 ? 1 : 0
      })
    },
    onEnableHotUpdateChange (value) {
      if (Number(value) !== 1) {
        this.form.force_hot_update = 0
      }
    },
    async uploadRequest (obj) {
      this.uploading = true
      try {
        const file = obj.file
        const ext = file.name.split('.').pop().toLowerCase()

        // 获取签名URL
        const params = {
          ext: ext,
          content_type: file.type || 'application/vnd.android.package-archive',
        }

        const res = await request.common('getAndroidApkSignedUrl', params)

        if (res.status === 200) {
          const uploadUrl = res.data.signedUrl
          const contentType = res.data.content_type
          const fileUrl = res.data.url

          // 使用 PUT 方法上传文件到签名URL
          await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': contentType,
            }),
            body: file,
          })

          this.form.loadurl = fileUrl
          this.$message.success('上传成功')
        } else {
          this.$message.error('获取上传地址失败')
        }
      } catch (err) {
        console.error('上传失败:', err)
        this.$message.error('上传失败: ' + (err.message || '未知错误'))
      } finally {
        this.uploading = false
      }
    },
    handleRemove (index) {
      this.form.loadurl = ''
    },
    getForm () {
      const data = filter.copyJson(this.form)
      data.app_type = Number(data.app_type) === APP_TYPE_CLB ? APP_TYPE_CLB : APP_TYPE_ALG
      if (data.app_type === APP_TYPE_CLB) {
        data.type = 0
        data.apk_signature = ''
        data.enable_hot_update = Number(data.enable_hot_update) === 1 ? 1 : 0
        data.force_hot_update = data.enable_hot_update === 1 && Number(data.force_hot_update) === 1 ? 1 : 0
      } else {
        data.enable_hot_update = 0
        data.force_hot_update = 0
      }
      return data
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createPlatformAndroidapkTestData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
          this.form.app_type = this.resolveAppTypeFromRoute()
          this.form.enable_hot_update = 0
          this.form.force_hot_update = 0
        }, () => {
          this.$router.push(this.tablePath)
        })
      })
    },
    update (id) {
      request.common('updatePlatformAndroidapkTestData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push(this.tablePath)
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-androidapk-test/pages/PlatformAndroidapkTestForm.vue